import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import SelectTableId from "../../../SelectTableId";
import SelectSubfields from "../../../EditFieldAttribute/SelectSubfields";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditLookup = (props) => {
  const { editFieldData, setEditFieldData, tableID } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };

  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("allow_add_entity")}
          checked={editFieldData.allow_add_entity}
          name="allow_add_entity"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("allow_edit_entity")}
          checked={editFieldData.allow_edit_entity}
          name="allow_edit_entity"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("show_default_option")}
          checked={editFieldData.show_default_option}
          name="show_default_option"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("prefill_filtered_data")}
          checked={editFieldData.prefill_filtered_data}
          name="prefill_filtered_data"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("mandatory")}
          checked={editFieldData.validate.mandatory}
          name="mandatory"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("exclude_duplicate")}
          checked={editFieldData.exclude_duplicate}
          name="exclude_duplicate"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <Input
        type="checkbox"
        label={getLabelForKey("backend_validation")}
        checked={editFieldData.validate.backend_validation}
        name="backend_validation"
        size="medium"
        containerClassName="w_50"
        onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
      />
      <SelectTableId
        label={getLabelForKey("select_entity")}
        name="table_id"
        value={editFieldData.table_id}
        onChange={(name, value) => handleChangeInput(name, value)}
        currentTableId={tableID}
        fiedlType={editFieldData.type}
      />
      <div style={{ marginTop: "4px" }}>
        <SelectSubfields
          label={getLabelForKey("display_fields")}
          name="display_fields"
          value={editFieldData.display_fields}
          onChange={(newFields) => handleChangeInput("display_fields", newFields)}
          tableId={editFieldData.table_id}
          tableType="statemachine"
        />
      </div>
      <div style={{ marginTop: "4px" }}>
        <SelectSubfields
          label={getLabelForKey("access_fields")}
          name="access_fields"
          value={editFieldData.access_fields}
          onChange={(newFields) => handleChangeInput("access_fields", newFields)}
          tableId={editFieldData.table_id}
          tableType="statemachine"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditLookup;
